import { palette } from '@billx/design-tokens';
import { createTheme, type PaletteMode } from '@mui/material';

import { commonTheme, type ThemeMode } from './common';

export const DEFAULT_APP_THEME: ThemeMode = 'light';

const lightTheme: Parameters<typeof createTheme>[0] = {
  palette: {
    mode: 'light' as PaletteMode,
    primary: {
      main: palette.light.primary,
      light: palette.light.primaryLight,
      dark: palette.light.primaryDark,
    },
    secondary: {
      main: palette.light.secondary,
      light: palette.light.secondaryLight,
      dark: palette.light.secondaryDark,
    },
    background: {
      default: palette.light.background,
      paper: palette.light.backgroundPaper,
    },
    text: {
      primary: palette.light.text,
      secondary: palette.light.textSecondary,
    },
  },
};

const darkTheme = {
  palette: {
    mode: 'dark' as PaletteMode,
    primary: {
      main: palette.dark.primary,
      light: palette.dark.primaryLight,
      dark: palette.dark.primaryDark,
    },
    secondary: {
      main: palette.dark.secondary,
      light: palette.dark.secondaryLight,
      dark: palette.dark.secondaryDark,
    },
    background: {
      default: palette.dark.background,
      paper: palette.dark.backgroundPaper,
    },
    text: {
      primary: palette.dark.text,
      secondary: palette.dark.textSecondary,
    },
  },
};

export const createAppTheme = (mode: ThemeMode) =>
  createTheme({
    ...commonTheme,
    ...(mode === 'light' ? lightTheme : darkTheme),
  });
